import React from 'react';
import { SnapIcon } from '../../SnapIcon';

export default function Header(): JSX.Element {
  return (
    <React.Fragment>
      <div className='text-lg font-medium leading-7'>Verify Your Account</div>
      <div className='text-sm font-normal leading-5 my-2'>
        U.S. State and Federal government regulations require us to verify your
        account to comply with banking laws that prevent money laundering and
        financing of prohibited organizations.
      </div>

      <div className='flex flex-row content-center my-4'>
        <SnapIcon
          icon={'locked-closed'}
          color={'#64748B'}
          size='md'
          className='self-start'
        />
        <p className='text-sm font-normal'>
          To keep you and your organization safe, our account verification
          process requires you to submit the following documents prior
          collecting and managing funds through Snap! Mobile.
        </p>
      </div>
      <div
        style={{
          backgroundColor: '#FEF3C7',
          justifyContent: 'center',
          alignContent: 'center',
          borderRadius: 10,
        }}
        className='p-4 my-2'
      >
        <p className='text-sm font-semibold line-clamp-5'>
          Please submit all documents, not doing so could delaying fundraising,
          collecting dues, and managing funds through Snap! Mobile.
        </p>
      </div>
    </React.Fragment>
  );
}
